import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { H3Atom } from '../../atoms/text-atoms/text-atoms';
import FilterBox from './filter-box';
import { SearchIconAtom } from '../../atoms/icon-atoms/nav-icon-atoms';
import { GTM_ID } from '../../../../common/constants/gtmIds';

const Search = ({
  id = 'search',
  title,
  label,
  fields,
  width,
  updateQueryArray,
  className,
}) => {
  const handleInput = event => {
    updateQueryArray(previousArray => {
      const filteredArray = previousArray.filter(element => element.id !== id);
      return [
        ...filteredArray,
        {
          id,
          fields,
          queryStrings: [event.target.value.toLowerCase()],
          isExact: false,
        },
      ];
    });
  };

  return (
    <div className={`${className} filter-block-element`}>
      {title && <H3Atom>{title}</H3Atom>}
      <FilterBox width={width} gtmId={GTM_ID.SEARCH_BAR}>
        <SearchIconAtom />
        <input
          type="search"
          aria-label="search"
          placeholder={label ? label : 'Type to search'}
          onChange={handleInput}
        />
      </FilterBox>
    </div>
  );
};

// === Search CSS ===
const StyledSearch = styled(Search)`
  ${({ width }) => (width ? `width: ${width};` : null)}
  ${H3Atom} {
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightRegular};
    margin: 0 0 ${vars.spacingXs} ${vars.spacingXs};
    &::first-letter {
      text-transform: uppercase;
    }
  }
  ${FilterBox} {
    ${SearchIconAtom} {
      height: 2.4rem;
    }
    input {
      width: 100%;
      height: 100%;
      ${vars.fontSize2}
      font-weight: ${vars.fontWeightRegular};
      border: none;
    }
  }
`;

export default StyledSearch;
